import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Client, ClientConfiguration } from '../clients/models/client.model';
import { CommonAPIService } from './commonAPI.service';

@Injectable({
  providedIn: 'root',
})
export class ClientService extends CommonAPIService {
  /**
   * Get list of clients but with only partial data. Each client will only have the following properties set :
   * - name
   * - nature
   * - apikey
   * - currentVersion
   * - functionalId
   * - latestVersion
   *
   * To get all data related to a specific client, you should call the {@link getClient} method
   */
  getClientList(): Observable<Client[]> {
    return this.get<Client[]>('v2/clients?fields=name,nature,apikey,currentVersion,functionalId,latestVersion');
  }

  getClient(clientFid: string): Observable<Client> {
    return this.get<Client>('v2/clients/' + clientFid);
  }

  getClientByApiKey(apiKey: string, lang: string, country: string): Observable<ClientConfiguration> {
    return this.get<ClientConfiguration>('v3/configurations/' + apiKey + '?lang=' + lang + '&country=' + country);
  }

  updateClient(client: Client, clientFid: string): Observable<Client> {
    return this.put<Client>('v2/clients/' + clientFid, client);
  }

  createClient(client: Client): Observable<Client> {
    return this.post<Client>('v2/clients', client);
  }
}
